//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return{
      Osname:[],
      Osdata:[],
      Oslist:[],
      Osnamec:['Windows'],
      Osid:[''],
      password:'',
      type:[
        {
          value:'new',
          label:'全新安装'
        },
        {
          value:'cpan',
          label:'只安装系统盘'
        }
      ],
      typeid:'new',
      yzm:'',
      captcha:'https://api.abeiyun.com/www/yzm.php?rnd='+Math.random(),
    }
  },
  mounted() {
    this.vps_oslist()
  },
  watch:{
    Osnamec(){
      this.Oslist = this.Osdata.map((item, index) => {
        return {
          value:item.id,
          name:item.sysName,
          os:item.win_linux
        }
      }).filter(item => {
        return item.os === this.Osnamec[0]
      })
      this.Osid[0] = this.Oslist[0].value
    }
  },
  methods:{
    async vps_oslist() {
      let data = 'cmd=vps_oslist'
      this.$http.post('https://api.abeiyun.com/www/vps.php',data).then(({data})=>{
        if(data.response == 200 ) {
          let hash = {};
          this.Osname = data.msg.map((item, index) => {
            return {
              value:item.win_linux,
              name:item.win_linux
            }
          }).reduceRight((item, next) => {
            hash[next.value] ? '' : hash[next.value] = true && item.push(next);
            return item
          }, []);
          this.Osdata = data.msg
          this.Oslist = this.Osdata.map((item, index) => {
            return {
              value:item.id,
              name:item.sysName,
              os:item.win_linux
            }
          }).filter(item => {
            return item.os === this.Osnamec[0]
          })
          this.Osid[0] = this.Oslist[0].value
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: '服务器繁忙，请重试',
          })
        }
      })
    },
    Choose(id) {
      this.typeid = id
    },
    changeYzm() {
      this.captcha = 'https://api.abeiyun.com/www/yzm.php?rnd='+Math.random()
    },
    async submit() {
      let data = 'cmd=os_setup'+
        '&id='+ this.$route.params.id +
        '&img_yzm='+ this.yzm +
        '&os_id='+ this.Osid[0] +
        '&password='+ this.password +
        '&setup_type='+ this.typeid
      this.$vux.loading.show({
        text: 'Loading'
      })
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/vps.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.loading.hide()
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {

            }
          })
        }else{
          this.$vux.loading.hide()
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/serveroperate/reinstallserver.vue